// extracted by mini-css-extract-plugin
export default {"itemsWrapper":"Block_itemsWrapper__hQK23","item":"Block_item__FPtHe","icon":"Block_icon__kQ8rX","title":"Block_title__5IYAA"};